<template>
    <v-sheet color="transparent" class="calendar-task-row-wrap">
        <v-row
            align="baseline"
            no-gutters
            style="margin-bottom: 1px"
            :class="['calendar-task-row', { 'weekend-task': isTaskOnWeekend }]"
            @click.stop.prevent="taskClick"
        >
            <v-col class="shrink" @click.stop.prevent="">
                  <router-link
                      :to="{ name: 'client_profile', params: { id: task.client_id }}"
                      style="text-decoration: none"
                  >
                      <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <AccountAvatar
                                    :color="task.client ? task.client.color : 'red'"
                                    :initials="task.client ? task.client.client_initials : 'err'"
                                    :inverted="isTaskFinished"
                                    :text-class="
                                        task.client.client_initials.length < 3 ? 'font-weight-medium body-2' : 'font-weight-medium'
                                    "
                                    size="24"
                                    :image-path="
                                        current_account.id === task.account_id && task.client.is_person ? current_account.avatar : ''
                                    "
                                    :tile="!task.client.is_person"
                                    class="pl-1 pr-2"
                                />
                            </div>
                        </template>
                        <span>{{ task.client.name }}</span>
                      </v-tooltip>
                  </router-link>
            </v-col>
            <v-col>
                <div>
                    <div
                        v-if="task.is_important"
                        class="mr-1 d-inline"
                    >
                        <icon
                            size="12"
                            color="secondary"
                            icon="Flag"
                        />
                    </div>
                    <div
                        v-if="task.depends_on && task.depends_on.length"
                        class="mr-1 d-inline"
                    >
                        <icon
                            size="12"
                            icon="Replace"
                        />
                    </div>
                    <span
                        class="caption calendar-item-text"
                        style="margin-right: 6px; padding-top: 4px; padding-bottom: 4px; padding-left: 2px; padding-right: 16px;"
                        :class="[
                            isTaskOverdue ? 'error--text' : '',
                            isTaskFinished ? 'grey--text font-weight-regular' : 'font-weight-medium'
                        ]"
                    >
                        <span
                            v-if="!task.due_date_only && task.due_date.substr(0, 10) === task.date.substr(0, 10)"
                            style="margin-right: 6px"
                            :class="[isTaskFinished ? '' : 'secondary--text']"
                        >
                            {{ task.due_date | format_time }}
                        </span>
                        <span
                            v-else-if="task.has_due_date"
                            style="margin-right: 6px"
                            :class="[isTaskFinished ? '' : 'secondary--text']"
                        >
                            {{ task.due_date | format_date_short }}
                        </span>
                        {{ task.title }}
                    </span>
                </div>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { computed } from "@vue/composition-api";
import AccountAvatar from "../../components/AccountAvatar";
import TaskModule from "../../store/modules/task";
import AccountModule from "../../store/modules/account";

export default {
    name: "CalendarTask",
    components: { AccountAvatar },
    props: {
        task: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const { current_account } = AccountModule();
        const { openTask } = TaskModule();

        const isTaskOverdue = computed(function() {
            return props.task.calc_status === "overdue";
        });
        const isTaskFinished = computed(function() {
            return props.task.status === "finished";
        });

        const isTaskOnWeekend = computed(function() {
            const dayIndex = new Date(Date.parse(props.task.date)).getDay();
            return dayIndex === 0 || dayIndex === 6;
        });

        const taskClick = function() {
            openTask(props.task.id != null && props.task.id !== 0 ? props.task.id : props.task.virtual_id);
        };

        return {
            isTaskOverdue,
            isTaskFinished,
            isTaskOnWeekend,
            current_account,
            taskClick
        };
    }
};
</script>
